import { createApp } from 'vue'
import Product from '~/js/models/product'
import FProductCard from '~/js/components/productCard'
const CLASS_NAME = 'js-product-list'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return
  Array.from(elements).forEach((element) => {
    try {
      const products = JSON.parse(element.dataset.products).map(
        (p) => new Product(p)
      )
      createApp({
        name: 'SnippetsProductList',
        data() {
          return {
            products,
          }
        },
        components: {
          FProductCard,
        },
        mounted() {
          window.zvRenderReviewSummary(element)
        },
      }).mount(element)
    } catch (error) {
      console.error(error)
    }
  })
})
